module.exports = __webpack_public_path__ + "img/logo_acadia_pharmaceuticals.276a2ac8.png";